import { IApiJsonResponse } from '../../../__core/Interfaces/IApiResponse';
import { IMaterial } from '../../../__core/Interfaces/IMaterial';
import { IAction } from '../../../__core/Interfaces/IAction';
import { IEvent } from '../../../__core/Interfaces/IEvent';
import MATERIAL_ACTIONS from './ActionTypes';
import { SideMenuResponse } from '../Types/SideMenuResponse';

export const getMaterialStart = (): IEvent => ({
  type: MATERIAL_ACTIONS.FETCH_MATERIAL_START,
});

export const getMaterialSuccess = (
  material: IApiJsonResponse<IMaterial>
): IAction<IApiJsonResponse<IMaterial>> => ({
  type: MATERIAL_ACTIONS.FETCH_MATERIAL,
  payload: material,
});

export const getMaterialFinish = (): IEvent => ({
  type: MATERIAL_ACTIONS.FETCH_MATERIAL_FINISH,
});

export const getSideMenuStart = (): IEvent => ({
  type: MATERIAL_ACTIONS.FETCH_SIDE_MENU_START,
});

export const getMaterialBase64Start = (): IEvent => ({
  type: MATERIAL_ACTIONS.FETCH_MATERIAL_BASE64_START,
});

export const getMaterialBase64Success = (
  material: IApiJsonResponse<string>
): IAction<IApiJsonResponse<string>> => ({
  type: MATERIAL_ACTIONS.FETCH_MATERIAL_BASE64,
  payload: material,
});

export const getMaterialBase64Finish = (): IEvent => ({
  type: MATERIAL_ACTIONS.FETCH_MATERIAL_BASE64_FINISH,
});

export const getSideMenuSuccess = (
  menuItems: SideMenuResponse
): IAction<SideMenuResponse> => ({
  type: MATERIAL_ACTIONS.FETCH_SIDE_MENU,
  payload: menuItems,
});

export const getSideMenuFinish = (): IEvent => ({
  type: MATERIAL_ACTIONS.FETCH_SIDE_MENU_FINISH,
});

export const clearMaterialDetails = (): IEvent => ({
  type: MATERIAL_ACTIONS.CLEAR_MATERIAL_DETAILS,
});
